export default class ArticleBookmark {
  constructor(private csrfToken: string) {}

  // ブックマークする
  //
  // @param articleId [number] 対象の記事 ID
  // @return [object]
  public async bookmark(articleId) {
    const response = await fetch(
      this.endpoint(articleId),
      this.defaultOption({ method: 'POST' })
    )
    if (!response.ok) {
      // 500 エラーの時とか
      return {
        status: 'NG',
        errors: []
      }
    }

    const body = await response.json()
    return body
  }

  // ブックマークを解除する
  //
  // @param articleId [number] 対象の記事 ID
  // @return [object]
  public async unbookmark(articleId) {
    const response = await fetch(
      this.endpoint(articleId),
      this.defaultOption({ method: 'DELETE' })
    )
    if (!response.ok) {
      return {
        status: 'NG',
        errors: []
      }
    }

    const body = await response.json()
    return body
  }

  private endpoint(articleId) {
    return `/articles/${articleId}/bookmark`
  }

  private defaultOption(override: RequestInit): RequestInit {
    return {
      method: 'GET',
      headers: this.defaultHeader(),
      mode: 'same-origin',
      credentials: 'same-origin',
      redirect: 'follow',
      ...override
    }
  }

  private defaultHeader() {
    return new Headers({
      'X-CSRF-TOKEN': this.csrfToken,
      'X-Requested-With': 'XMLHttpRequest'
    })
  }
}
